/* Version F only: replace the fire-pit merchandising image everywhere except its own PDP. */
(() => {
  'use strict';

  const replacement = 'https://cdn.shopify.com/s/files/1/0931/1164/8597/files/ph-outdoor-furniture-set.jpg?v=1788848585';
  const excludedPath = '/products/outdoor-corner-sofa-set-with-fire-pit-table-10-seater-garden-furniture-set';
  const oldImageTokens = [
    'outdoor_sofa_set_april_26.png',
    'Generated_Image_March_25_2026_-_2_53PM.png'
  ];

  if (location.pathname.replace(/\/$/, '') === excludedPath) return;

  const containsOldImage = value => {
    const text = String(value || '');
    return oldImageTokens.some(token => text.includes(token));
  };

  const replaceImage = img => {
    if (!img || img.dataset.phfOutdoorFurnitureReplacement === 'true') return;
    if (!containsOldImage(img.getAttribute('src')) && !containsOldImage(img.getAttribute('srcset')) && !containsOldImage(img.currentSrc)) return;

    img.dataset.phfOutdoorFurnitureReplacement = 'true';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = replacement;
    if (!img.alt || /fire\s*pit/i.test(img.alt)) img.alt = 'Panel Hub outdoor furniture set';
  };

  const replaceSource = source => {
    if (!source || !containsOldImage(source.getAttribute('srcset'))) return;
    source.setAttribute('srcset', replacement);
  };

  const replaceInlineBackground = element => {
    if (!element || !element.getAttribute) return;
    const style = element.getAttribute('style');
    if (!containsOldImage(style)) return;
    element.style.backgroundImage = `url("${replacement}")`;
  };

  const scan = root => {
    if (!root) return;
    if (root.matches) {
      if (root.matches('img')) replaceImage(root);
      if (root.matches('source')) replaceSource(root);
      replaceInlineBackground(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('img').forEach(replaceImage);
      root.querySelectorAll('source[srcset]').forEach(replaceSource);
      root.querySelectorAll('[style]').forEach(replaceInlineBackground);
    }
  };

  scan(document);

  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') {
        scan(record.target);
        return;
      }
      record.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'style']
  });
})();
